import Event from "../../../sdk/src/utils/event";
import {SYSTEM_EVENTS} from "../../../sdk/src/events/events";

export class SdkEventsTrigger {
    gameOpen(eventData: {gameType: number; isReal: boolean}): void {
        Event.fire(SYSTEM_EVENTS.GAME_OPEN, {
            gametype: eventData.gameType,
            gameType: eventData.gameType,
            isReal: eventData.isReal
        });
    }

    gameClosed(eventData: {gameType: number; isReal: boolean; isGamePlayed: boolean; showNextGameSuggestion: boolean}): void {
        Event.fire(SYSTEM_EVENTS.CLOSE_GAME, {
            gametype: eventData.gameType,
            gameType: eventData.gameType,
            isReal: eventData.isReal,
            isGamePlayed: eventData.isGamePlayed,
            showNextGameSuggestion: eventData.showNextGameSuggestion
        });
    }

    keepAlive(): void {
        Event.fire(SYSTEM_EVENTS.EXTEND_USER_TIME_TO_LIVE);
    }

    liveGameSwitched(): void {
        Event.fire(SYSTEM_EVENTS.LIVE_GAME_SWITCHED);
    }

    hybridGameLoadingIndicatorClosed(): void {
        Event.fire(SYSTEM_EVENTS.LOADING_INDICATOR_EMBEDDED_CLOSED_BY_X);
    }

    updateMarketingParams(marketingParams: any): void {
        Event.fire(SYSTEM_EVENTS.INCOMING_MARKETING_DATA, marketingParams);
    }


}